import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import classes from "./ImageMagnifier.module.css";

const ImageMagnifier = (props) => {
  const { src, alt, className, zoomLevel = 3, ...rest } = props;
  const [isMagnifierVisible, setIsMagnifierVisible] = useState(false);
  const [[magnifierWidth, magnifierHeight], setMagnifierSize] = useState([
    0, 0,
  ]);
  const magnifierContainer = useRef();

  const mouseEnteredHandler = () => {
    setIsMagnifierVisible(true);
  };

  const mouseMovedHandler = (event) => {
    const imageElement = event.currentTarget;
    const { top, left } = imageElement.getBoundingClientRect();
    const cursorX = event.pageX - left - window.scrollX;
    const cursorY = event.pageY - top - window.scrollY;
    magnifierContainer.current?.style.setProperty(
      "--cursor-x",
      `${(cursorX / magnifierWidth) * 100}%`
    );
    magnifierContainer.current?.style.setProperty(
      "--cursor-y",
      `${(cursorY / magnifierHeight) * 100}%`
    );
  };

  const mouseLeavedHandler = () => {
    setIsMagnifierVisible(false);
  };

  useEffect(() => {
    if (magnifierContainer.current) {
      const { width, height } =
        magnifierContainer.current.getBoundingClientRect();
      magnifierContainer.current.style.setProperty(
        "--magnifier-width",
        `${width}px`
      );
      magnifierContainer.current.style.setProperty(
        "--magnifier-height",
        `${height}px`
      );
      setMagnifierSize([width, height]);
      magnifierContainer.current.style.setProperty(
        "--img-src",
        `url('${src}')`
      );
      magnifierContainer.current.style.setProperty("--zoom-level", zoomLevel);
    }
  }, [src, zoomLevel]);

  // view
  return (
    <div
      className={classNames(classes["magnifier"], className)}
      ref={magnifierContainer}
    >
      <img
        src={src}
        alt={alt}
        {...rest}
        onMouseEnter={mouseEnteredHandler}
        onMouseMove={mouseMovedHandler}
        onMouseLeave={mouseLeavedHandler}
        className={classes["magnifier__img"]}
      />
      <div
        className={classNames(classes["magnifier__zoomed-div"], {
          [classes["magnifier__zoomed-div--hidden"]]: !isMagnifierVisible,
        })}
      />
    </div>
  );
};

export default ImageMagnifier;

ImageMagnifier.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};
